import { Link } from "react-router-dom";
import { useNoindex } from "../lib/seo";

export default function NotFound() {
  useNoindex(true);
  return (
    <div className="max-w-3xl mx-auto px-5 py-32 text-center" data-testid="not-found-page">
      <p className="eyebrow mb-5">404</p>
      <h1 className="font-playfair text-5xl text-neutral-900 mb-5">
        We couldn't find that page.
      </h1>
      <p className="text-neutral-600 mb-8">
        The link may be broken, or the page may have been moved.
      </p>
      <Link
        to="/"
        className="inline-flex items-center px-6 py-3 rounded-full bg-indigo-800 text-surface text-sm font-semibold hover:bg-indigo-900 transition-colors"
      >
        Back to home
      </Link>
    </div>
  );
}
